<template>
  <o-form :title="$t('medtastic.workshop')" :url="'/api/medtastic/workshops/' + $route.params.id + '?include=registrations'"
          class="ortic-form-horizontal" ref="form">
    <template slot-scope="props">
      <b-row>
        <b-col>
          <o-input :errorField="'title'" :label="$t('core.title')" v-model="props.item.title"/>
          <o-input :label="$t('medtastic.region')" v-model="props.item.region"/>
          <o-input :label="$t('medtastic.location')" v-model="props.item.location"/>
          <o-value-select :errorField="'language'" :items="workshop_locale" :label="$t('core.language')" v-model="props.item.language"/>
          <o-file-upload :label="$t('medtastic.picture')" v-model="props.item.picture" accept="image/*"/>
          <o-file-upload :label="$t('medtastic.document')" v-model="props.item.pdf_document" accept="application/pdf"/>
          <o-input :label="$t('medtastic.speaker')" v-model="props.item.speaker"/>
          <o-file-upload :label="$t('medtastic.speaker_signature')" v-model="props.item.speaker_signature" accept="image/*"/>
          <o-checkbox :label="$t('medtastic.signup_active')" v-model="props.item.signup_active"></o-checkbox>
          <o-form-group :label="$t('medtastic.signup_hint')">
            <div class="input-group">
              <o-vue-editor v-model="props.item.signup_hint" class="w-100"/>
            </div>
          </o-form-group>
        </b-col>
        <b-col>
          <o-datepicker :errorField="'date'" :typeable="false" :label="$t('core.date')" v-model="props.item.date"/>
          <o-timepicker :errorField="'time'" :label="$t('medtastic.time')" v-model="props.item.time"/>
          <o-form-group :label="$t('core.description')">
            <div class="input-group">
              <o-vue-editor v-model="props.item.description" class="w-100"/>
            </div>
          </o-form-group>
          <o-form-group :label="$t('medtastic.email_comment')">
            <div class="input-group">
              <o-vue-editor v-model="props.item.email_comment" class="w-100"/>
            </div>
          </o-form-group>
          <o-input :errorField="'credits'" :label="$t('medtastic.credits')" v-model="props.item.credits"/>
        </b-col>
      </b-row>
    </template>
    <template slot="child" slot-scope="props">
      <b-tabs>
        <b-tab :title="$t('medtastic.registrations')" active>
          <o-card>
            <div class="table-responsive">
              <b-btn @click.prevent="xlsx()" variant="primary">
                <fa icon="file-excel"/> {{$t('medtastic.export')}}
              </b-btn>
              <table class="table">
                <thead>
                <tr>
                  <th>{{$t('core.title')}}</th>
                  <th>{{$t('core.first_name')}}</th>
                  <th>{{$t('core.last_name')}}</th>
                  <th>{{$t('core.email')}}</th>
                  <th>{{$t('medtastic.institution')}}</th>
                  <th>{{$t('medtastic.institution_address')}}</th>
                  <th>{{$t('medtastic.city')}}</th>
                  <th>{{$t('medtastic.postal_code')}}</th>
                  <th>{{$t('core.language')}}</th>
                  <th>{{$t('medtastic.certificate')}}</th>
                  <th>{{$t('medtastic.notification')}}</th>
                  <th class="text-right">
                    <b-btn @click.prevent="open()" variant="primary">
                      <fa icon="plus"/>
                    </b-btn>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(registration, i) in props.item.registrations">
                  <td>{{registration.title}}</td>
                  <td>{{registration.first_name}}</td>
                  <td>{{registration.last_name}}</td>
                  <td>{{registration.email}}</td>
                  <td>{{registration.institution}}</td>
                  <td>{{registration.institution_address}}</td>
                  <td>{{registration.city}}</td>
                  <td>{{registration.postal_code}}</td>
                  <td>{{workshop_locale[registration.language]}}</td>
                  <td class="text-nowrap text-center">
                    <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                      <o-button v-if="registration.id" type="button" variant="primary"
                                @click.prevent="certificate(i)">
                        <fa icon="file-pdf"/>
                      </o-button>
                    </div>
                  </td>
                  <td class="text-nowrap text-center">
                    <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                      <o-button v-if="registration.id" type="button" variant="secondary"
                                :loading="sending.includes(i + 'confirmation')"
                                :title="$t('medtastic.confirmation_btn_tooltip_text')" @click.prevent="sendEmail(i)">
                        <fa icon="user-check"/>
                      </o-button>
                      <o-button v-if="registration.id" type="button" variant="primary"
                                :loading="sending.includes(i + 'reminder')"
                                :title="$t('medtastic.reminder_btn_tooltip_text')"
                                @click.prevent="sendEmail(i, 'reminder')">
                        <fa icon="calendar-alt"/>
                      </o-button>
                    </div>
                  </td>
                  <td class="text-right text-nowrap">
                    <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                      <b-btn @click.prevent="props.item.registrations.splice(i, 1)" variant="secondary">
                        <fa icon="times"/>
                      </b-btn>
                      <b-btn @click.prevent="open(i)" variant="primary">
                        <fa icon="pencil-alt"/>
                      </b-btn>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </o-card>
        </b-tab>
      </b-tabs>
      <b-modal :title="$t('medtastic.registration')" :ok-title="$t('core.save')" @ok="ok" id="modal-add-edit"
               ref="addEditModal">
        <o-input :label="$t('core.title')" v-model="formSchema.title"></o-input>
        <o-input :label="$t('core.first_name')" v-model="formSchema.first_name"></o-input>
        <o-input :label="$t('core.last_name')" v-model="formSchema.last_name"></o-input>
        <o-input :label="$t('medtastic.institution')" v-model="formSchema.institution"></o-input>
        <o-input :label="$t('medtastic.institution_address')" v-model="formSchema.institution_address"></o-input>
        <o-input :label="$t('medtastic.city')" v-model="formSchema.city"></o-input>
        <o-input :label="$t('medtastic.postal_code')" v-model="formSchema.postal_code"></o-input>
        <o-input :label="$t('core.email')" v-model="formSchema.email"></o-input>
        <span class="text-muted">{{ $t('medtastic.participant_email_hint_text') }}</span>
        <o-value-select :label="$t('core.language')" ref="langSelector" class="mt-3" :items="workshop_locale" v-model="formSchema.language">
        </o-value-select>
      </b-modal>
    </template>
  </o-form>
</template>

<script>
  import axios from 'axios'

  export default {
    data: () => ({
      workshop_locale: window.config.workshop_locale,
      i: null,
      formSchema: {},
      sending: []
    }),
    methods: {
      open (i = null) {
        this.reset()
        this.i = i
        if (this.i !== null) {
          this.formSchema = Object.assign({}, this.formSchema, this.$refs.form.item.registrations[this.i])
        }
        this.$refs.addEditModal.show()
      },
      ok () {
        if (this.i !== null) {
          this.$set(this.$refs.form.item.registrations, [this.i], this.formSchema)
        } else {
          const lenght = this.$refs.form.item.registrations.length
          delete this.formSchema.id
          this.$set(this.$refs.form.item.registrations, [lenght], this.formSchema)
        }
        this.$refs.addEditModal.hide()
      },
      reset () {
        this.formSchema = Object.assign({}, this.formSchema, {
          title: null,
          first_name: null,
          last_name: null,
          institution: null,
          institution_address: null,
          city: null,
          postal_code: null,
          email: null,
          language: null
        })
        this.i = null
      },
      sendEmail (i = null, type = 'confirmation') {
        if (i !== null) {
          this.sending.push(i + '' + type)
          axios.post('/api/medtastic/workshop_registrations/email', {
            'id': this.$refs.form.item.registrations[i].id,
            'type': type
          }).then((response) => {
            this.sending = []
          }).catch((error) => {
            this.sending = []
            console.log(error)
          })
        }
      },
      certificate (i = null) {
        if (i !== null) {
          let registration = this.$refs.form.item.registrations[i]
          axios.post('/api/medtastic/workshop_registrations/certificate', {
            'id': registration.id
          }, { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(response.data,
              registration.first_name + '_' + registration.last_name + '.pdf', 'application/pdf'
            )
          }).catch((error) => {
            console.log(error)
          })
        }
      },
      xlsx () {
        var $self = this
        axios.post('/api/medtastic/workshop_registrations/export', {
          'id': $self.$refs.form.item.id
        }, { responseType: 'arraybuffer' })
            .then((response) => {
              require('downloadjs')(response.data,
                  $self.$refs.form.item.title + ' ' + $self.$i18n.t('medtastic.registrations') + '.xlsx',
                  'application/vnd.ms-excel'
              )
            }).catch((error) => {
              console.log(error)
            })
      }
    }
  }
</script>
